const I18nKeys = {
    "ecap.solicitaion.not.found": "Solicitação não encontrada!",
    "ecap.solicitaion.is.finalized": "Essa solicitação já foi finalizada.",
    "ecap.solicitation.ecap.link": "Essa solicitação está associada a ECAP em aberto ",
    "ecap.solicitation.log.link": "Esta solicitação foi utilizada no Sentry View e possui registros de auditoria vinculados",
}

export default I18nKeys;
